<div class="component-list-grid grid-flex grid-full-center" (click)="toggleView()">
  <div class="component-list-grid__single" [class.component-list-grid__single--active]="isGridViewActivated">
    <img src="../../assets/images/icon-grid-view.svg" alt="" />
  </div>

  <div class="component-list-grid__single" [class.component-list-grid__single--active]="!isGridViewActivated">
    <img src="../../assets/images/icon-list-view.svg" alt="" />
  </div>
</div>
